import PropTypes from 'prop-types';
import React from 'react';
import { pageContext } from 'ctm-util-functions';
import { List } from 'immutable';

import { SimpleFlexbox } from '../../../../../flexbox/flexbox';
import { Text } from '../../../../../text/text';
import { BrandLogo } from '../../../../../brand_logo/brand_logo';

import style from '../features_header/features_header.css';

/**
 * Displays a FeaturesHeaderFilteredProductsList with Brand Logos of unavailable quotes
 * @param {Object} args The arguments
 * @param {Immutable.List} args.filteredQuotes - list of brands that weren't available
 * @param {Object} args.contentProps - contentProps for Text component from schema
 * @param {Object} args.visualProps - visualProps for Text component from schema
 * @returns {Node} A featuresHeaderNotAvailable Component
 * @constructor
 */
const FeaturesHeaderFilteredProductsList = ({ filteredQuotes, contentProps, visualProps }) => {
    /**
     * Iterates through  the unavailable quotes returning a flexbox containing the product name and Brand Logo
     * @returns {FeaturesHeaderFilteredProductsList} A FeaturesHeaderFilteredProductsList Component
     */
    const vertical = pageContext.getVertical();
    const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}` };
    let featureFilteredOutQuotes = filteredQuotes;
    if (vertical === 'home-contents-insurance') {
        /**
         *  The below filtering is only applied on H&C due to the business requirements.
         *  Unlike the usual rendering of all partners in filtered quotes, now we only render quotes
         *  with an available product, which is determined by looking at quote.productMeta.available
         */
        if (filteredQuotes !== undefined) {
            featureFilteredOutQuotes = filteredQuotes.filter((temp) => temp.quote.getIn(['productMeta', 'available']) !== false);
        }
    }
    if (vertical === 'car-insurance') {
        /**
         *  ticket link: https://dev.azure.com/ctmaus/CTM/_workitems/edit/7675
         *  the below code will only display Carpeesh currently due to the comparison criteria.
         *  We can generalize it later.
         */
        if (filteredQuotes !== undefined) {
            featureFilteredOutQuotes = filteredQuotes.filter((temp) => temp.quote.getIn(['productMeta', 'price', 'monthlyPremium']) === 0);
        }
    }
    return featureFilteredOutQuotes.size > 0 ? (
        <div className={style.notAvailableList}>
            <SimpleFlexbox padding="all">
                { /* @TODO remove shaped props from parent once we get to that stage */}
                <Text {...contentProps} {...visualProps} />
            </SimpleFlexbox>
            {featureFilteredOutQuotes.map((result) => (
                <SimpleFlexbox key={result.quote.getIn(['providerMeta', 'code'])} padding="all_small">
                    <BrandLogo
                        stateProps={{ product: result.quote }}
                        elementProps={brandLogoElementProps} />
                </SimpleFlexbox>
            ))}
        </div>
    ) : null;
};

FeaturesHeaderFilteredProductsList.propTypes = {
    filteredQuotes: PropTypes.instanceOf(List).isRequired,
    contentProps: PropTypes.object.isRequired,
    visualProps: PropTypes.object
};

export { FeaturesHeaderFilteredProductsList };
